import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

import { TranslateModule } from '@ngx-translate/core';

import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';

import { PipesModule } from '../../misc/pipes/pipes.module';
import { AgmCoreModule, MarkerManager } from '@agm/core';

import { TableComponent, TableToggleColumnsDialogComponent } from './table.component';

// datepicker
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    FormsModule,
    MatChipsModule,
    MatCardModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatTooltipModule,
    MatSlideToggleModule,
    PipesModule,
    AgmCoreModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FlexLayoutModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatSortModule,
    MatSelectModule,

  ],
  declarations: [
    TableComponent,
    TableToggleColumnsDialogComponent,
  ],
  entryComponents: [
    TableToggleColumnsDialogComponent,
  ],
  exports: [
    TableComponent
  ]
})
export class TableModule { }
